import React from 'react';
import moment from 'moment';
import AlertBar from './form/AlertBar';

const ContentLockNotice = ({ config }) => (
    <div className="content-lock-notice">
        <AlertBar variant="warning">
            Listings are locked for editing until {moment(config.ContentLockEndsAt).format('D MMMM YYYY')}.
            You can still view this listing, but changes can't be saved.
        </AlertBar>
    </div>
);

export default ContentLockNotice;
